import Proxy from '../Proxy';

class ManagerDailyReportProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('manager-reports/daily', parameters);
  }

  showDaily(managerUuid) {
    return this.submit('get', `${this.endpoint}/date/${managerUuid}`);
  }
}

export default ManagerDailyReportProxy;
